import { Component, Injector, OnDestroy, OnInit,ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MyApplicationsService } from '@app/pages/my-application/my-app-service.service';
import { HttpService } from '@app/@core/services/http.service';
import { DataGridVO } from '@app/shared/custom-component/data-grid/data-grid.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { forkJoin, Subject } from 'rxjs';
import { CommonService } from '@app/shared/services/common.service';
import { AlertService } from '@app/@core/services/alert.service';
import { API_ENDPOINTS } from '@app/shared/constants/apiconstants';
import { ClientReferenceInformation, OrderInformation, PaymentRequest, ProcessingInformation } from '../../payment/payments.constant';
import { take, takeUntil } from 'rxjs';
import { LocalService } from '@app/@core/services/local.service';
import { PaymentsService } from '../payments.service';
import { DataStoreService } from '@pics-core/dynamic';
import { PaymentResetService } from './payment-reset.service';
import { LoaderService } from '@core/services/loader.service';
import { ROLE_ID } from '@app/shared/constants/rolesConstant.model';

@Component({
  standalone: false,
  selector: 'app-paymentform',
  templateUrl: './paymentform.component.html',
  styleUrls: ['./paymentform.component.scss']
})
export class PaymentformComponent implements OnInit, OnDestroy {
  name: string = 'Fee and Payment';
  showModal: boolean = false;
  showPaymentProcessingModal: boolean = false;
  applicationStatusData: any;
  personData: any;
  applicationID: any;
  applicationTotalFee: any;
  /** Gross fee before any credit deduction — sent to the API as totalAmount. */
  grossApplicationTotalFee: any;
  /** Educator credit balance fetched from the server (display only). */
  educatorCreditBalance = 0;
  /** Amount of credit that will be applied (min of balance and gross fee). */
  appliedCredit = 0;
  /** True when educator fee balance covers the full gross fee — card form fields are disabled. */
  isCreditOnly = false;
  LiceanceEndrosementFee: any;
  backgroundCheckFee: any;
  VeteranExemption: any;
  extensionFee: any;
  applicationFee: any;
  paymentSuccess = false;
  today: Date = new Date();
  paymentForm: FormGroup;
  showsecurityCode = false;
  cardType: string = '';
  cardTypeIcon: string = '';
  errorMessages: any = {};
  private destroy$ = new Subject<void>();
  toastMessages: any;
  toastMessage: {};
  toastTitle: string;
  toastMessageText: string;
  toastType: string;
  showToast: boolean;
  toastTimer: any;
  paymentTableData = [];
  placeholderMessages: any;
  placeholderMessage: {};
  paymentResponse: any;
  userinfo: any;
  applicationNumber: any;
  injector: Injector;
  dataStore: DataStoreService;
  private route: ActivatedRoute;
  paymentFail = false;
  hasAuthorizedTransaction: boolean;
  authorizedTransactionData: any;
   genericMessages: any[] = [];
  genericMessage: any = {};
    showAppFeeTooltip = false;
    private invalidAttemptTimestamps: number[] = [];
  // Additional payment mode (new endorsements / veteran payback required by staff)
  isAdditionalPayment = false;
  needsAddlEndorsement = false;
  needsVeteranPayback = false;
  cdApplicationStatus: string = '';
  additionalEndorsementCount = 0;
  additionalEndorsementFee = 0;
  additionalEndorsementUnitFee = 0;
  veteranAdjustmentFee = 0;
  // Normal path: endorsement unit price and count stored by fee preview popup
  endorsementUnitFee = 0;
  endorsementCount = 0;

  get showPaymentForm(): boolean {
    const result = !this.paymentSuccess && (this.isAdditionalPayment || !this.hasAuthorizedTransaction);
    console.log('[PaymentForm] showPaymentForm:', result, '| paymentSuccess:', this.paymentSuccess, '| isAdditionalPayment:', this.isAdditionalPayment, '| hasAuthorizedTransaction:', this.hasAuthorizedTransaction);
    return result;
  }

  get showPaymentHistory(): boolean {
    const result = (this.hasAuthorizedTransaction || this.paymentSuccess)
      && !(this.isAdditionalPayment && !this.paymentSuccess);
    console.log('[PaymentForm] showPaymentHistory:', result, '| paymentSuccess:', this.paymentSuccess, '| isAdditionalPayment:', this.isAdditionalPayment, '| hasAuthorizedTransaction:', this.hasAuthorizedTransaction);
    return result;
  }

  get submitButtonLabel(): string {
    if (this.cdApplicationStatus === '19') return 'Re-submit';
    if (this.cdApplicationStatus === '40') return 'Pay';
    return 'Submit';
  }

  private readonly invalidAttemptWindowMs = 60 * 1000;
  private readonly maxInvalidAttemptsPerWindow = 5;
  hidePreviousNextButtons: boolean = false;
  isGeneratingPDF: boolean = false;
  addEndrose:any;

  paymentTableHeaders = [
    { dataField: 'transactionId', caption: 'Transaction ID' },
    { dataField: 'cardName', caption: 'Name on Card' },
    { dataField: 'cardNumber', caption: 'Card Number (Last 4 digits)' },
    { dataField: 'amount', caption: 'Amount' },
    { dataField: 'date', caption: 'Date', dataType: 'date' },
    { dataField: 'status', caption: 'Status' }
  ];
  paymentDataGridConfig = DataGridVO.create({
    customHeaders: this.paymentTableHeaders,
    data: this.paymentTableData,
    showActionsColumn: false,
    showFiltering: false,
    showSearchRow: false,
    showPaging: false,
    customPageSize: 5,
    customNoDataText: 'No payment data',
    role: 'payment',
    activeTab: 'payment',
    visibleColumns: {
      status: true,
      date: true,
      amount: true,
      transactionId: true,
      application_id: true
    }
  });
  formatMaskedCardNumber(cardNumber: string): string {
    if (!cardNumber) return '';
    const digits = cardNumber.replace(/\D/g, '');
    if (digits.length < 4) return '****-****';
    return '****-****-' + digits.slice(-4);
  }
  onPaymentSuccess() {
    this.paymentSuccess = true;
    if (this.paymentResponse) {
      const payment = this.paymentResponse;
      // Format submitTimeUtc to MM/DD/YYYY
      let formattedDate = '';
      if (payment.submitTimeUtc) {
        formattedDate = this.commonservice.getFormatedDate(payment.submitTimeUtc);

      }
      // Mask card number using the formatMaskedCardNumber function
      const formCardNumber = this.paymentForm.get('number')?.value || '';
      const maskedCardNumber = this.formatMaskedCardNumber(formCardNumber);
      // Get card name from paymentForm
      const formCardName = this.paymentForm.get('cardName')?.value || '';
      this.paymentTableData = [
        {
          paymentId: payment.id,
          applicationId: this.sessionStorage.getItem('applicationID'),
          cardName: formCardName,
          cardNumber: maskedCardNumber,
          amount: Math.floor(payment.orderInformation?.amountDetails?.totalAmount || this.applicationTotalFee),
          status: this.formatStatusText(payment.status),
          date: formattedDate,
          transactionId: payment.transactionId || payment.id || '',
          application_number: this.sessionStorage.getItem('youthId'),
        }
      ];
    }
    this.paymentDataGridConfig = DataGridVO.create({
      customHeaders: this.paymentTableHeaders,
      data: this.paymentTableData,
      showActionsColumn: false,
      showFiltering: false,
      showSearchRow: false,
      showPaging: false,
      customPageSize: 5,
      customNoDataText: 'No payment data',
      role: 'payment',
      activeTab: 'payment',
      visibleColumns: {
        status: true,
        date: true,
        amount: true,
        transactionId: true,
        application_id: true
      }
    });
    console.log('DEBUG paymentDataGridConfig', this.paymentDataGridConfig);
    console.log('DEBUG paymentTableData', this.paymentTableData);
    this.checkAuthorizedTransaction();
  }

  constructor(
    private readonly router: Router,
    private readonly appService: MyApplicationsService,
    private readonly httpService: HttpService,
    private fb: FormBuilder,
    private commonservice: CommonService,
    private readonly alertService: AlertService,
    private sessionStorage: LocalService,
    private paymentservice: PaymentsService,
    private cdr: ChangeDetectorRef,
    private paymentResetService: PaymentResetService,
    private loaderService: LoaderService,
    injector: Injector
  ) {
    this.injector = injector;
    this.dataStore = injector.get<DataStoreService>(DataStoreService);

    const applicationIDString = this.sessionStorage.getItem('applicationID');
    console.log(this.sessionStorage)
    this.applicationID = applicationIDString || null;
    this.checkAuthorizedTransaction()
    this.paymentForm = this.fb.group({
      number: ['', [
        Validators.required,
        this.cardNumberValidator.bind(this)
      ]],
      cardName: ['', [
        Validators.required,
        this.cardNameValidator.bind(this)
      ]],
      expDate: ['', [
        Validators.required,
        this.expDateValidator.bind(this)
      ]],
      securityCode: ['', [
        Validators.required,
        this.securityCodeValidator.bind(this)
      ]],
      zip: ['', [
        Validators.required,
        this.zipCodeValidator.bind(this)
      ]]
    });
    this.checkReadOnlyModeToHidePreviousNextButton();
    this.addEndrose = JSON.parse(this.sessionStorage.getItem('currApplicationType'));
  }

  ngOnInit(): void {

    this.paymentResetService.resetForm$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.paymentForm) {
          this.paymentForm.reset();
          this.cardType = '';
          this.cardTypeIcon = '';
          this.showsecurityCode = false;
          this.cdr.markForCheck();
        } else {
        }
      });

    this.loadMessages();
    this.httpService.get('/domain/lookup?requestType=APPLICATION_STATUS').subscribe({
      next: (item: any) => {
        this.applicationStatusData = item.data;
        // After loading lookup data, check and set navigation data if application is submitted
        this.loadApplicationStatusAndSetNavigation();
      },
      error: error => {
        console.error('Error loading dropdown data:', error);
      }
    });
    this.applicationTotalFee = this.sessionStorage.getItem('applicationTotalFee');
    this.LiceanceEndrosementFee = this.sessionStorage.getItem('LiceanceEndrosementFee');
    this.endorsementUnitFee = parseFloat(this.sessionStorage.getItem('additionalEndorsementUnitFee') || '0') || 0;
    this.endorsementCount = Number(this.sessionStorage.getItem('additionalEndorsementCount')) || 0;
    this.applicationFee = this.sessionStorage.getItem('applicationFee');
    this.backgroundCheckFee = this.sessionStorage.getItem('backgroundCheckFee');
    this.VeteranExemption = this.sessionStorage.getItem('Veteran Exemption');
    this.extensionFee = this.sessionStorage.getItem('extensionFee');
    this.addEndrose = JSON.parse(this.sessionStorage.getItem('currApplicationType'));

    const appFeeNum = parseFloat(this.applicationFee) || 0;
    const bgCheckFeeNum = parseFloat(this.backgroundCheckFee) || 0;
    const endorsementFeeNum = parseFloat(this.LiceanceEndrosementFee) || 0;
    const veteranExemptionNum = parseFloat(this.VeteranExemption) || 0;
    const extensionFeeNum = parseFloat(this.extensionFee) || 0;
    if (this.addEndrose !== 'Add Endorsement') {
      // Background check fee is mandatory for this application — roll into Application Fee display.
      this.applicationFee = appFeeNum + bgCheckFeeNum;
      this.grossApplicationTotalFee = parseFloat((appFeeNum + bgCheckFeeNum + endorsementFeeNum - veteranExemptionNum + extensionFeeNum).toFixed(2));
    } else {
      this.grossApplicationTotalFee = parseFloat((endorsementFeeNum - veteranExemptionNum + extensionFeeNum).toFixed(2));
    }
    this.applicationTotalFee = this.grossApplicationTotalFee;

    // Fetch educator credit balance for display. totalAmount sent to API remains gross;
    // the API applies the credit atomically.
    const appIdForCredit = this.sessionStorage.getItem('applicationID') || '';
    if (appIdForCredit) {
      this.httpService.get(`/payments/credit-preview?appId=${appIdForCredit}`)
        .pipe(take(1), takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            const bal = parseFloat(String(res?.data?.creditBalance ?? res?.creditBalance ?? '0')) || 0;
            this.educatorCreditBalance = bal;
            this.appliedCredit = Math.round(Math.min(bal, this.grossApplicationTotalFee) * 100) / 100;
            this.isCreditOnly = this.grossApplicationTotalFee > 0 && this.appliedCredit >= this.grossApplicationTotalFee;
            this.updateCardFields();
          },
          error: () => {
            this.educatorCreditBalance = 0;
            this.appliedCredit = 0;
            this.isCreditOnly = false;
            this.updateCardFields();
          }
        });
    }

    const personDataString = this.sessionStorage.getObj('personData');
    console.log(personDataString)
    this.personData = personDataString || null;
    console.log(this.personData)
    const applicationId = this.sessionStorage.getItem('applicationID') || '';
    console.log(applicationId)
    const applicationIDString = this.sessionStorage.getItem('applicationID');
    console.log(applicationIDString)
    this.applicationID = applicationIDString || null;
    this.checkAuthorizedTransaction()

    this.paymentResetService.startInactivityTimer();

  }

 checkAuthorizedTransaction(): void {
    const payload = { applicationId: Number(this.sessionStorage.getItem('applicationID')) };
    const personData = this.sessionStorage.getObj('personData') || {};
const applicantName = [personData.first_name, personData.last_name].filter(Boolean).join(' ');
const youthNumber = JSON.parse(this.sessionStorage.getItem('youthNumber') || 'null');
const formatDateLong = (date: Date) => {
      const day = date.getDate();
      const month = date.toLocaleString('default', { month: 'long' });
      const year = date.getFullYear();
      return `${day} ${month} ${year}`;
    };
    this.httpService.post('/payments/transactions', payload).subscribe({
      next: (resp: any) => {
        let transactions = Array.isArray(resp) ? resp : (Array.isArray(resp?.data) ? resp.data : []);
        const appId = Number(this.applicationID);
        if (Array.isArray(transactions)) {
          this.paymentTableData = transactions
            .filter((tx: any) => {
              const txAppId = Number(tx.application_id);
              const txStatus = String(tx.transaction_status_value || '').toUpperCase();
              return txAppId === appId && txStatus === 'AUTHORIZED';
            })
            .map((tx: any) => ({

              transactionId: tx.transaction_id || tx.payment_transaction_id || '',
              cardName: '',
              cardNumber: '',
              amount: Math.floor(tx.amount || 0),
              status: this.formatStatusText(tx.transaction_status_value || ''),
              date: this.commonservice.getFormatedDate(tx.transaction_date || tx.created_date || ''),
              receiptPaymentDate:tx.transaction_date,
              application_id: tx.application_id || '',
              applicationNumber: youthNumber,
              applicantName,
              receiptDate: formatDateLong(new Date()),
              invoiceNumber: tx.invoice_number,
            }));
          // Set flag true if at least one authorized transaction for this appId exists
          this.hasAuthorizedTransaction = this.paymentTableData.length > 0;
          console.log('[PaymentForm] checkAuthorizedTransaction result — hasAuthorizedTransaction:', this.hasAuthorizedTransaction, '| tx count:', this.paymentTableData.length, '| isAdditionalPayment at this point:', this.isAdditionalPayment);
          this.authorizedTransactionData = this.paymentTableData[0] || null;
          this.paymentDataGridConfig = DataGridVO.create({
            customHeaders: this.paymentTableHeaders,
            data: this.paymentTableData,
            showActionsColumn: false,
            showFiltering: false,
            showSearchRow: false,
            showPaging: false,
            customPageSize: 5,
            customNoDataText: 'No payment data',
            role: 'payment',
            activeTab: 'payment',
            visibleColumns: {
              status: true,
              date: true,
              amount: true,
              transactionId: true,
              application_id: true
            }
          });
        } else {
          console.warn('No transactions array found in response.');
        }
      },
      error: err => {
        console.error('Error fetching transactions:', err);
      }
    });
  }

  loadApplicationStatusAndSetNavigation(): void {
    const applicationId = this.sessionStorage.getItem('applicationID');
    if (!applicationId) {
      console.error('No application ID found in session storage');
      return;
    }

    const userId = this.sessionStorage.getItem('id');
    if (!userId) {
      console.error('No user ID found in session storage');
      return;
    }

    // Call API to get all applications for the user
    this.httpService.post('/registration/applications', { userId: userId })
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (response: any) => {
          if (response && response.data && Array.isArray(response.data.data)) {
            // Find the current application by ID
            const currentApplication = response.data.data.find(
              (app: any) => String(app.id) === String(applicationId) || String(app.application_id) === String(applicationId)
            );

            if (currentApplication) {
              this.cdApplicationStatus = String(currentApplication.cd_application_status || '');
              // Check for additional payment flags set by staff during review
              const needsAddlEndorsement = currentApplication.additional_endorsements === true;
              const needsVeteranPayback = currentApplication.veteran_status_payment_required === true;
              this.needsAddlEndorsement = needsAddlEndorsement;
              this.needsVeteranPayback = needsVeteranPayback;
              console.log('[PaymentForm] Application flags — additional_endorsements:', currentApplication.additional_endorsements, '| veteran_status_payment_required:', currentApplication.veteran_status_payment_required, '| needsAddlEndorsement:', needsAddlEndorsement, '| needsVeteranPayback:', needsVeteranPayback);
              if (needsAddlEndorsement || needsVeteranPayback) {
                this.isAdditionalPayment = true;
                console.log('[PaymentForm] isAdditionalPayment set to TRUE');
                this.additionalEndorsementCount = needsAddlEndorsement
                  ? (Number(currentApplication.additional_endorsement_count) || 0)
                  : 0;
                this.fetchAdditionalPaymentFees(needsAddlEndorsement, needsVeteranPayback);
              }

              // Check if application status is submitted (not draft)
              const appStatus = (currentApplication.application_status || '').toLowerCase();
              const isSubmitted = appStatus !== 'in progress, not submitted' && appStatus !== 'draft' && appStatus !== '';

              if (isSubmitted && currentApplication.application_status) {
                // Match the status with lookup key and set navigationData
                const statusKey = this.findKeyByValue(this.applicationStatusData, currentApplication.application_status);

                const existingNavigationData = this.sessionStorage.getObj('navigationData');
                let navigationData = existingNavigationData || {};

                if (!navigationData.bannerheader) {
                  navigationData.bannerheader = {};
                }

                // navigationData.bannerheader['Application Status'] = currentApplication.application_status;

                // Only set Resubmitted Date if it exists in the response and is not null/empty/---
                if (currentApplication.re_submitted_date && currentApplication.re_submitted_date !== '---') {
                  navigationData.bannerheader['Resubmitted Date'] = this.commonservice.getFormatedDate(currentApplication.re_submitted_date);
                }

                this.sessionStorage.setObj('navigationData', navigationData);

                console.log('Navigation data set for submitted application:', navigationData);
              } else {
                console.log('Application is not submitted yet, navigation data will be set on payment submission');
              }
            } else {
              console.warn('Current application not found in the response');
            }
          } else {
            console.warn('Invalid response format from applications API');
          }
        },
        error: (error) => {
          console.error('Error fetching application data:', error);
        }
      });
  }

  private fetchAdditionalPaymentFees(needsEndorsement: boolean, needsVeteranPayback: boolean): void {
    this.httpService.get('/domain/lookup?requestType=FEE_CATEGORY')
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const feeLookup: any[] = Array.isArray(res?.data) ? res.data : [];
          const parseOptFee = (row: any): number => {
            try {
              const opt = typeof row?.optionaldata === 'string' ? JSON.parse(row.optionaldata) : row?.optionaldata;
              return parseFloat(opt?.fee) || 0;
            } catch { return 0; }
          };

          if (needsEndorsement) {
            const endRow = feeLookup.find((r: any) => String(r.key) === '3');
            this.additionalEndorsementUnitFee = endRow ? parseOptFee(endRow) : 75;
            this.additionalEndorsementFee = this.additionalEndorsementUnitFee * this.additionalEndorsementCount;
          }

          if (needsVeteranPayback) {
            const vetRow = feeLookup.find((r: any) => String(r.key) === '9');
            this.veteranAdjustmentFee = vetRow ? parseOptFee(vetRow) : 25;
          }

          this.grossApplicationTotalFee = parseFloat(
            (this.additionalEndorsementFee + this.veteranAdjustmentFee).toFixed(2)
          );
          this.applicationTotalFee = this.grossApplicationTotalFee;

          // Recompute applied credit against new gross total
          if (this.educatorCreditBalance > 0) {
            this.appliedCredit = Math.round(
              Math.min(this.educatorCreditBalance, this.grossApplicationTotalFee) * 100
            ) / 100;
            this.isCreditOnly =
              this.grossApplicationTotalFee > 0 && this.appliedCredit >= this.grossApplicationTotalFee;
            this.updateCardFields();
          }
        },
        error: () => {
          console.error('Failed to load FEE_CATEGORY lookup for additional payment fees');
        }
      });
  }

  showPaymentSuccessModal(): void {
    this.showModal = true;
    setTimeout(() => {
      this.updateApplicationStatus();
      this.createApplicationTimeline();
      this.closeModal();
      this.router.navigate(['pages/my-app']);
    }, 5000);
  }

  createApplicationTimeline(): void {

    const draftStatusKey = this.findKeyByValue(this.applicationStatusData, 'SUBMITTED');
    const applicationTimelineData = {
      application_id: this.applicationID,
      cd_application_status: draftStatusKey,
      person_id: this.personData.person_id,
    };

    // this.appService.createApplicationTimeline(applicationTimelineData).subscribe({
    //   next: response => {
    //     if (response.data.success === true) {
    //       console.log('Application timeline created successfully:', response);
    //     } else {
    //       console.warn('Application timeline creation returned false success status');
    //     }
    //   },
    //   error: error => {
    //     console.error('Error creating application timeline:', error);
    //   }
    // });
  }

  findKeyByValue(data: any, value: string): any {
    if (!data || !Array.isArray(data)) return null;

    const item = data.find(item => item.value === value);
    return item ? item.key : null;
  }
  closeModal(): void {
    this.showModal = false;
  }
  updateApplicationStatus(): void {
    const draftStatusKey = this.findKeyByValue(this.applicationStatusData, 'SUBMITTED');
    let input = {
      application_id: this.applicationID,
      cd_application_status: draftStatusKey,
    }
    this.appService.updateApplicationStatus(input).subscribe({
      next: response => {
        if (response.data.success === true) {
          console.log('Application timeline created successfully:', response);
        } else {
          console.warn('Application timeline creation returned false success status');
        }
      },
      error: error => {
        console.error('Error creating application timeline:', error);
      }
    });

  }

  private loadMessages(): void {
    forkJoin([
      this.httpService.get(API_ENDPOINTS.LOOKUP_MESSAGES),
      this.httpService.get('/domain/lookup?requestType=TOAST MESSAGES'),
      this.httpService.get(API_ENDPOINTS.PLACEHOLDER_MESSAGES),
            this.httpService.get('/domain/lookup?requestType=GENERIC MESSAGES'),
    ]).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (responses: any[]) => {
        this.placeholderMessages = responses[2].data;
                this.genericMessages = responses[3].data;
        if (responses[0]?.data) {
          responses[0].data.forEach(msg => {
            this.errorMessages[msg.key] = msg.value;
          });
        }
        if (responses[1]?.data) {
          this.toastMessage = {};
          responses[1].data.forEach(msg => {
            if (msg.key && msg.value !== undefined) {
              this.toastMessage[msg.key] = msg.value;
            }
          });
        }
        this.placeholderMessage = {};
        this.placeholderMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.placeholderMessage[message.key] = message.value;
          }
        });
         this.genericMessage = {};
        this.genericMessages.forEach(message => {
          if (message.key && message.value !== undefined) {
            this.genericMessage[message.key] = message.value;
          }
        });
      },
      error: (err) => {
        console.error('Failed to load messages:', err);
      }
    });
  }


  onExpDatePaste(event: ClipboardEvent) {
    event.preventDefault();
    let paste = (event.clipboardData?.getData('text') || '').replace(/[^0-9]/g, '');
    if (paste.length > 4) paste = paste.slice(0, 4);
    let formatted = paste;
    if (paste.length > 2) {
      formatted = paste.slice(0, 2) + '/' + paste.slice(2);
    }
    this.paymentForm.get('expDate')?.setValue(formatted, { emitEvent: false });
  }
  onExpDateBlur() {
    const expDateCtrl = this.paymentForm.get('expDate');
    expDateCtrl?.markAsTouched();
    expDateCtrl?.updateValueAndValidity();
    this.clearSecurityCodeOnValidationError();
  }
  onExpDateInput() {
    const expDateCtrl = this.paymentForm.get('expDate');
    let value = (expDateCtrl?.value || '').replace(/[^0-9]/g, '');
    if (value.length > 4) value = value.slice(0, 4);
    let formatted = value;
    if (value.length > 2) {
      formatted = value.slice(0, 2) + '/' + value.slice(2);
    }
    expDateCtrl?.setValue(formatted);
    expDateCtrl?.markAsTouched();
    expDateCtrl?.updateValueAndValidity();
    this.clearSecurityCodeOnValidationError();
  }


  onReset() {
    this.paymentForm.reset();
    this.cardType = '';
    this.cardTypeIcon = '';
    this.showsecurityCode = false;
  }

  private updateCardFields(): void {
    const cardFields = ['number', 'cardName', 'expDate', 'securityCode', 'zip'];
    for (const name of cardFields) {
      const ctrl = this.paymentForm.get(name);
      if (!ctrl) continue;
      if (this.isCreditOnly) {
        ctrl.disable({ emitEvent: false });
      } else {
        ctrl.enable({ emitEvent: false });
      }
    }
  }

  // onCardNumberInput() {
  //   const raw = this.paymentForm.get('number')?.value || '';
  //   const sanitized = raw.replace(/[^0-9]/g, '');
  //   this.paymentForm.get('number')?.setValue(this.formatCardNumber(sanitized), { emitEvent: false });
  //   this.detectCardType(sanitized);
  //   this.cardNumberValidator({ value: sanitized });
  // }

  formatCardNumber(num: string): string {
    return num.replace(/(.{4})/g, '$1 ').trim();
  }

  detectCardType(num: string) {
    this.cardType = '';
    this.cardTypeIcon = '';
    if (/^4/.test(num)) {
      this.cardType = 'Visa';
      this.cardTypeIcon = 'assets/images/visa.svg';
    } else if (/^(5[1-5]|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)/.test(num)) {
      this.cardType = 'Mastercard';
      this.cardTypeIcon = 'assets/images/Mastercard.svg';
    } else if (/^3[47]/.test(num)) {
      this.cardType = 'American Express';
      this.cardTypeIcon = 'assets/images/American Express.svg';
    } else if (/^(6011|65|64[4-9]|622(12[6-9]|1[3-9][0-9]|[2-8][0-9]{2}|9[01][0-9]|92[0-5]))/.test(num)) {
      this.cardType = 'Discover';
      this.cardTypeIcon = 'assets/images/Discover.svg';
    }
  }


  cardNumberValidator(control: any) {
    const value = (control.value || '').replace(/\D/g, '');
    if (!value) return { required: true };
    this.detectCardType(value);
        if (!this.isValidCardTypeLength(value)) return { invalidCardLength: true };
    // Only allow Visa, Mastercard, Discover, American Express
    const allowedTypes = ['Visa', 'Mastercard', 'Discover', 'American Express'];
    if (!allowedTypes.includes(this.cardType)) {
      return { notAcceptedCardType: true };
    }
    const bypassCards = ['5100000000001008', '4000000000002002'];
    if (bypassCards.includes(value)) {
      return null;
    }
    if (!this.luhnCheck(value)) {
      return { invalidCardNumber: true };
    }
    return null;
  }
   onCardNumberBlur() {
    const ctrl = this.paymentForm.get('number');
    if (ctrl) {
      ctrl.markAsTouched();
      ctrl.updateValueAndValidity();
    }
    this.clearSecurityCodeOnValidationError();
  }
  cardNameValidator(control: any) {
    const value = (control.value || '').trim();
    if (!value) return { required: true };
    if (!/^[A-Za-z .'-]+$/.test(value)) return { invalidName: true };
    if (value.length < 2 || value.length > 26) return { invalidNameLength: true };
    return null;
  }
  onCardNameInput() {
    const ctrl = this.paymentForm.get('cardName');
    if (ctrl) {
      let value = (ctrl.value || '').replace(/[^A-Za-z .'-]/g, '');
      // Limit to 26 characters
      if (value.length > 26) value = value.slice(0, 26);
      ctrl.setValue(value, { emitEvent: false });
    }
     const secCtrl = this.paymentForm.get('securityCode');
      if (secCtrl) {
        secCtrl.updateValueAndValidity();
      }
      this.clearSecurityCodeOnValidationError();
  }
  // Restrict card number input to max 19 digits and numeric only
  onCardNumberInput() {
    const ctrl = this.paymentForm.get('number');
    if (ctrl) {
      let value = (ctrl.value || '').replace(/[^0-9]/g, '');
      if (value.length > 19) value = value.slice(0, 19);
      ctrl.setValue(this.formatCardNumber(value), { emitEvent: false });
      this.detectCardType(value);
      this.cardNumberValidator({ value });
       const secCtrl = this.paymentForm.get('securityCode');
      if (secCtrl) {
        secCtrl.updateValueAndValidity();
      }
    }
    this.clearSecurityCodeOnValidationError();
  }
  expDateValidator(control: any) {
    const raw = (control.value || '').replace(/\s/g, '');
    let match = raw.match(/^(\d{2})\/?(\d{2,4})$/);
    if (!match) return { invalidExpDate: true };
    let month = parseInt(match[1], 10);
    let year = match[2].length === 2 ? parseInt('20' + match[2], 10) : parseInt(match[2], 10);
    if (month < 1 || month > 12) return { invalidExpMonth: true };
    const now = new Date();
    const exp = new Date(year, month - 1, 1);
    const minExp = new Date(now.getFullYear(), now.getMonth(), 1);
    if (exp < minExp) return { expired: true };
    if (year > now.getFullYear() + 20 || (year === now.getFullYear() + 20 && month > now.getMonth() + 1)) {
 if (year > now.getFullYear() + 20 || (year === now.getFullYear() + 20 && month > now.getMonth() + 1)) {
      const msg = this.placeholderMessage && this.placeholderMessage['M0171']
        ? this.placeholderMessage['M0171']
        : 'Enter an expiration year between the current year and 20 years from now.';
      return { tooFarFuture: true, M0171: msg };
    }    }
    return null;
  }

  securityCodeValidator(control: any) {
    const value = (control.value || '').replace(/\D/g, '');
    if (!value) return { required: true };
    let expected = 3;
    if (this.cardType && this.cardType.trim().toLowerCase() === 'american express') {
      expected = 4;
    }
    if (value.length !== expected) return { invalidsecurityCode: true };
    return null;
  }
  zipCodeValidator(control: any) {
    const originalValue = (control.value || '');
    const trimmedValue = originalValue.trim();

    // Block if the original value starts with space or hyphen
    if (originalValue.length > 0 && /^[\s-]/.test(originalValue)) {
      return { startsWithInvalid: true };
    }

    if (trimmedValue.length < 3) {
      return { minlength: true };
    }
    if (trimmedValue.length > 10) {
      return { maxlength: true };
    }
    if (!/^[A-Za-z0-9\s-]+$/.test(trimmedValue)) {
      return { pattern: true };
    }
    return null;
  }
   onZipInput() {
    const ctrl = this.paymentForm.get('zip');
    if (ctrl) {
      let value = (ctrl.value || '').replace(/[^A-Za-z0-9\s-]/g, '');
      value = value.replace(/^[\s-]+/, '');
      // Limit to 10 characters
      if (value.length > 10) value = value.slice(0, 10);
      ctrl.setValue(value, { emitEvent: false });
    }
    this.clearSecurityCodeOnValidationError();
  }
  onZipPaste(event: ClipboardEvent) {
    event.preventDefault();
    const ctrl = this.paymentForm.get('zip');
    if (ctrl && event.clipboardData) {
      let value = event.clipboardData.getData('text').replace(/[^A-Za-z0-9\s-]/g, '');
      // Remove leading spaces and hyphens
      value = value.replace(/^[\s-]+/, '');
      // Limit to 10 characters
      if (value.length > 10) value = value.slice(0, 10);
      ctrl.setValue(value, { emitEvent: false });
    }
  }

  private clearSecurityCodeOnValidationError(): void {
    const securityCodeControl = this.paymentForm.get('securityCode');
    if (!securityCodeControl || !securityCodeControl.value) {
      return;
    }

    const hasInteractedValidationError = Object.keys(this.paymentForm.controls)
      .filter(controlName => controlName !== 'securityCode' && controlName !== 'zip')
      .some(controlName => {
        const control = this.paymentForm.get(controlName);
        return !!control && control.invalid && (control.touched || control.dirty);
      });

    if (hasInteractedValidationError) {
      securityCodeControl.setValue('', { emitEvent: false });
      securityCodeControl.markAsUntouched();
    }
  }

  private pruneInvalidAttempts(now: number): void {
    this.invalidAttemptTimestamps = this.invalidAttemptTimestamps.filter(
      timestamp => now - timestamp < this.invalidAttemptWindowMs
    );
  }

  private hasExceededInvalidAttemptLimit(now: number = Date.now()): boolean {
    this.pruneInvalidAttempts(now);
    return this.invalidAttemptTimestamps.length >= this.maxInvalidAttemptsPerWindow;
  }

  private registerInvalidAttempt(now: number = Date.now()): void {
    this.pruneInvalidAttempts(now);
    this.invalidAttemptTimestamps.push(now);
  }

  private getInvalidAttemptLimitMessage(now: number = Date.now()): string {
    this.pruneInvalidAttempts(now);
    const oldestAttempt = this.invalidAttemptTimestamps[0];
    if (!oldestAttempt) {
      return 'Too many invalid attempts. Please try again after 1 minute.';
    }
    const retryAfterMs = this.invalidAttemptWindowMs - (now - oldestAttempt);
    const retryAfterSeconds = Math.max(1, Math.ceil(retryAfterMs / 1000));
    return `Too many invalid attempts. Please try again in ${retryAfterSeconds} seconds.`;
  }
  isValidCardTypeLength(num: string): boolean {
    if (this.cardType === 'Visa') return [13, 16, 19].includes(num.length);
    if (this.cardType === 'Mastercard') return num.length === 16;
    if (this.cardType === 'American Express') return num.length === 15;
    if (this.cardType === 'Discover') return [16, 19].includes(num.length);
    return true;
  }
  luhnCheck(cardNumber: string): boolean {
    let sum = 0;
    let isEven = false;
    for (let i = cardNumber.length - 1; i >= 0; i--) {
      let digit = parseInt(cardNumber[i], 10);
      if (isEven) {
        digit *= 2;
        if (digit > 9) digit -= 9;
      }
      sum += digit;
      isEven = !isEven;
    }
    return (sum % 10) === 0;
  }

  onsecurityCodeInput() {
    const ctrl = this.paymentForm.get('securityCode');
    if (ctrl) {
      let value = (ctrl.value || '').replace(/[^0-9]/g, '');
      const cardNumberRaw = (this.paymentForm.get('number')?.value || '').replace(/\D/g, '');
      this.detectCardType(cardNumberRaw);
      let expected = 3;
      if (this.cardType && this.cardType.trim().toLowerCase() === 'american express') {
        expected = 4;
      }
      if (value.length > expected) value = value.slice(0, expected);
      ctrl.setValue(value, { emitEvent: false });
    }
  }
  getOrderInformationFromSession(): OrderInformation {
    const data: OrderInformation = {
      amountDetails: {
        // Send gross amount — the API applies educator credit atomically server-side.
        totalAmount: this.grossApplicationTotalFee ?? this.applicationTotalFee ?? '',
        currency: 'USD',
      }
    };
    if (!data) {
      throw new Error('Order information missing from session');
    }
    return data;
  }
  getProcessingInformation(): ProcessingInformation {
    const data: ProcessingInformation = {
      capture: true
    };
    return data;
  }
  getClientReferenceInformation(): ClientReferenceInformation {
    let code = this.sessionStorage.getItem('orderSequence');
    if (!code) {
      code = '0000001';
    } else {
      code = (parseInt(code, 10) + 1).toString().padStart(7, '0');
    }
    this.sessionStorage.setItem('orderSequence', code);
    return { code };
  }
  onCardNameBlur() {
    const ctrl = this.paymentForm.get('cardName');
    if (ctrl) {
      const trimmed = (ctrl.value || '').trim();
      ctrl.setValue(trimmed, { emitEvent: false });
      ctrl.markAsTouched();
      ctrl.updateValueAndValidity();
    }
  }
   onSubmit() {
    if (this.hasExceededInvalidAttemptLimit()) {
      this.showFailureToastMsg(this.getInvalidAttemptLimitMessage());
      return;
    }
    if (this.paymentForm.invalid) {
      this.registerInvalidAttempt();
      this.clearSecurityCodeOnValidationError();

      if (this.hasExceededInvalidAttemptLimit()) {
        this.showFailureToastMsg(this.getInvalidAttemptLimitMessage());
        return;
      }
      this.showFailureToastMsg(this.getToastMessage('T0021', 'Please fill all required fields.'));
      return;
    }

    // Show processing modal immediately
    this.showPaymentProcessingModal = true;
    this.cdr.detectChanges();

    const form = this.paymentForm.value;
    const [expirationMonth, expirationYearShort] = (form.expDate || '').split('/');
    const expirationYear = expirationYearShort ? ('20' + expirationYearShort) : '';
    const payload: PaymentRequest = {
      appId: this.sessionStorage.getItem('applicationID') || '',
      oldappID: this.sessionStorage.getItem('oldapplicationID') || '',
      PaymentInfo: {
        clientReferenceInformation: this.getClientReferenceInformation(),
        processingInformation: this.getProcessingInformation(),
        paymentInformation: {
          card: {
            number: this.commonservice.encrypt(form.number || ''),
            expirationMonth: expirationMonth || '',
            expirationYear: expirationYear || '',
            securityCode: form.securityCode || '',
          },
        },
        orderInformation: this.getOrderInformationFromSession(),
      }
    };

    const payEndpoint = this.isAdditionalPayment ? '/payments/pay-additional' : '/payments/pay';
    this.httpService.post(payEndpoint, payload)
      .pipe(take(1), takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          const rawStatus = String(res?.status || '');
          const isApproved = res?.status === 'AUTHORIZED' && rawStatus === 'AUTHORIZED';

          if (isApproved) {
            this.invalidAttemptTimestamps = [];
            this.paymentResponse = res.data;
            this.onPaymentSuccess();

            // Set navigation data with application status from payment response
            const existingNavigationData = this.sessionStorage.getObj('navigationData');

            let navigationData;

            // Parse if it's a string, otherwise use as-is
            if (typeof existingNavigationData === 'string') {
              try {
                navigationData = JSON.parse(existingNavigationData);
              } catch (e) {
                navigationData = {};
              }
            } else if (existingNavigationData && typeof existingNavigationData === 'object') {
              navigationData = existingNavigationData;
            } else {
              navigationData = {};
            }

            // Ensure bannerheader exists
            if (!navigationData.bannerheader) {
              navigationData.bannerheader = {};
            }
             if (navigationData.bannerheader["Created Date"]) {
              delete navigationData.bannerheader["Created Date"];
            }
            if (res?.submitTimeUtc){
              navigationData.bannerheader["Submitted Date"] = this.commonservice.getFormatedDate(res.submitTimeUtc);
            }

            this.sessionStorage.setObj('navigationData', navigationData);

            this.notification();

            // Hide processing modal, show success toast, redirect to dashboard
            this.showPaymentProcessingModal = false;
            this.alertService.success(this.toastMessage['T0021'], true);
            this.router.navigate(['pages/my-app']);
            return;
          } else {
            // Payment failed: hide modal, reset form, show T0023, stay on page
            this.showPaymentProcessingModal = false;
            this.paymentForm.reset();
            this.cardType = '';
            this.cardTypeIcon = '';
            this.showsecurityCode = false;
            this.paymentFail = true;
            this.notificationOnPaymentFailure();
            this.alertService.error(this.toastMessage['T0023']);
            return;
          }

        },
        error: () => {
          this.showPaymentProcessingModal = false;
          this.notificationOnPaymentFailure();
          this.showFailureToastMsg(this.getToastMessage('T0021', 'Payment failed. Please try again.'));
        }
      });
  }

  notification() {
    const appId = this.sessionStorage.getItem('youthNumber') || '';
    const userId = this.sessionStorage.getItem('id');

    if (this.isAdditionalPayment) {
      // For additional payments
      if (this.needsVeteranPayback) {
        // Veteran payment: send to educator user
        const staffPayload = {
          priority: "High",
          message: `An additional payment is required for application ${appId}. Resolve all deficiencies and complete the payment on the Fees and Payment tab before resubmitting your application.`,
          actionurl: "/pages/fingerprint-portal",
          userid: userId,
          customformid: 1,
          isnew: true,
          isactive: true
        };
        this.paymentservice.Submitnotifiction(staffPayload).pipe(take(1), takeUntil(this.destroy$)).subscribe({
          next: (res: any) => {
            if (res.data.success) {
              console.log(`Notification sent successfully for veteran additional payment`);
            }
            else {
              console.error(`Error while sending notification for veteran additional payment.`);
            }
          },
          error: err => {
            console.error(`Error sending notification for veteran additional payment:`, err);
          }
        });
      } else if (this.needsAddlEndorsement) {
        // Endorsement payment: send to educator user
        const endorsementPayload = {
          priority: "High",
          message: `An additional payment is required for application ${appId}. Complete the payment on the Fees and Payment tab in your application to continue processing.`,
          actionurl: "/pages/fingerprint-portal",
          userid: userId,
          customformid: 1,
          isnew: true,
          isactive: true
        };
        this.paymentservice.Submitnotifiction(endorsementPayload).pipe(take(1), takeUntil(this.destroy$)).subscribe({
          next: (res: any) => {
            if (res.data.success) {
              console.log(`Notification sent successfully for endorsement additional payment`);
            }
            else {
              console.error(`Error while sending notification for endorsement additional payment.`);
            }
          },
          error: err => {
            console.error(`Error sending notification for endorsement additional payment:`, err);
          }
        });
      }
    } else {
      // Send to educator user for regular payments
      const educatorPayload = {
        priority: "High",
        message: `Payment successful. Application ${appId} has been submitted.`,
        actionurl: "/pages/fingerprint-portal",
        userid: userId,
        customformid: 1,
        isnew: true,
        isactive: true
      };
      this.paymentservice.Submitnotifiction(educatorPayload).pipe(take(1), takeUntil(this.destroy$)).subscribe({
        next: (res: any) => {
          if (res.data.success) {
          }
          else {
            console.error('Error while sending notification. Please try again later.');
          }
        },
        error: err => {
          console.error('Error sending notification:', err);
        }
      });
    }
  }

  private redirectToDashboard(): void {
    this.router.navigate(['pages/my-app']);
  }

  private getToastMessage(key: string, fallback: string): string {
    return this.toastMessage?.[key] || fallback;
  }

  showFailureToastMsg(msg: string, title = 'Error') {
    if (msg === this.errorMessages['M0163']) {
      this.paymentFail = true;
      this.showToast = false;
      return;
    }
    this.toastTitle = title;
    this.toastMessageText = msg;
    this.toastType = 'error';
    this.showToast = true;
    this.setShortToastTimer();
    window.scrollTo(0, 0);
  }

  showSuccessToastMsg(msg: string, title = 'Success') {
    this.toastTitle = title;
    this.toastMessageText = msg;
    this.toastType = 'success';
    this.showToast = true;
    this.setShortToastTimer();
    window.scrollTo(0, 0);
  }

  setShortToastTimer() {
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
    this.toastTimer = setTimeout(() => {
      this.showToast = false;
    }, 4000);
  }

  closeToast() {
    this.showToast = false;
    if (this.toastTimer) {
      clearTimeout(this.toastTimer);
    }
  }

  // Show full card number while typing, mask only on blur
  maskCardNumberOnBlur(event: any): void {
    const input = event.target as HTMLInputElement;
    let rawValue = input.value.replace(/\s/g, '');
    if (!rawValue || rawValue.length <= 4) {
      input.value = rawValue;
      return;
    }
    let masked = '*'.repeat(rawValue.length - 4) + rawValue.slice(-4);
    // Optionally format with spaces every 4 digits
    masked = masked.replace(/(.{4})/g, '$1 ').trim();
    input.value = masked;
  }

  showFullCardNumberOnFocus(event: any): void {
    const input = event.target as HTMLInputElement;
    let rawValue = this.paymentForm.get('number')?.value || '';
    input.value = rawValue;
  }

  moveToNext(): void {
    const tabList = JSON.parse(this.dataStore.getData('TABCONFIGLIST') || '[]');
    const currentTabIndex = tabList?.findIndex(tab => tab.id == 3700);
    const parentGridPageInfo = this.sessionStorage.getObj('backToGridPage')
      ? this.sessionStorage.getObj('backToGridPage')
      : this.sessionStorage.getObj('parentGridPage')
        ? this.sessionStorage.getObj('parentGridPage')
        : {};
    let nextTab = null;
    let islastTab = null;
    if (currentTabIndex !== -1 && currentTabIndex == tabList.length - 1) {
      islastTab = tabList[currentTabIndex + 1] ? false : true;
    }
    currentTabIndex !== -1 ? (nextTab = tabList[currentTabIndex + 1]) : null;
    let lastTabId = null;
    if (islastTab) {
      lastTabId = tabList[currentTabIndex]?.id;
    }
    const nextTabIndex = currentTabIndex + 1;
    if (islastTab) {
      if (parentGridPageInfo.id) {
        this.router.navigate([`/pages/dynamic-search/search/${parentGridPageInfo?.id}`], { relativeTo: this.route });
      } else {
        this.router.navigate([`/pages/${parentGridPageInfo.name}`], { relativeTo: this.route });
      }
    } else if (nextTab && nextTab.id) {
      this.dataStore.setData('FORM_SUBMISSION_SUCCESS', {
        isRoute: true,
        nextPage: nextTabIndex,
        submissionId: this.commonservice.getPrimaryIdFromDynamicRoutingUrl(this.router.url)
      });
      return;
    } else {
      return;
    }
  }

  moveToPrevious(): void {
    const tabList = JSON.parse(this.dataStore.getData('TABCONFIGLIST') || '[]');
    const currentTabIndex = tabList?.findIndex(tab => tab.id == 3700);
    const parentGridPageInfo = this.sessionStorage.getObj('backToGridPage')
      ? this.sessionStorage.getObj('backToGridPage')
      : this.sessionStorage.getObj('parentGridPage')
        ? this.sessionStorage.getObj('parentGridPage')
        : {};
    let previousTab = null;
    let isFirstTab = null;
    if (currentTabIndex === 0) {
      isFirstTab = true;
    }
    currentTabIndex > 0 ? (previousTab = tabList[currentTabIndex - 1]) : null;
    const previousTabIndex = currentTabIndex - 1;
    if (isFirstTab) {
      if (parentGridPageInfo.id) {
        this.router.navigate([`/pages/dynamic-search/search/${parentGridPageInfo?.id}`], { relativeTo: this.route });
      } else {
        this.router.navigate([`/pages/${parentGridPageInfo.name}`], { relativeTo: this.route });
      }
    } else if (previousTab && previousTab.id) {
      this.dataStore.setData('FORM_SUBMISSION_SUCCESS', {
        isRoute: true,
        nextPage: previousTabIndex,
        submissionId: this.commonservice.getPrimaryIdFromDynamicRoutingUrl(this.router.url)
      });
      return;
    } else {
      return;
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.paymentResetService.stopInactivityTimer();
  }


  checkReadOnlyModeToHidePreviousNextButton() {
    let appMode = JSON.parse(this.sessionStorage.getItem('applicationmode'));
    let appStatus = JSON.parse(this.sessionStorage.getItem('applicationStatus'));
    let currApplicationType = JSON.parse(this.sessionStorage.getItem('currApplicationType'));
    const userRoleIdRaw = this.sessionStorage.getItem('role_id'); // string from storage
    const userRoleId = Number(userRoleIdRaw); // normalize to number
    let isReadOnlyMode = false;
    if (appMode === 'view') {
      isReadOnlyMode = true;

    } else if (currApplicationType === 'License Extension') {
      isReadOnlyMode = true;
    } else {
      const allowedStatuses = [
        'In Progress, Not Submitted',
        'DEFICIENT',
        'Deficiency',
        'Deficiency + BG Denied',
        'Deficiency Pending + BG Pending',
        'Deficiency Pending + BG Approved',
        'Deficiency Pending'
      ];
      const appStatusTrimmed = appStatus ? appStatus.trim() : '';
      if (appStatusTrimmed && !allowedStatuses.includes(appStatusTrimmed) && userRoleId === 405) {
        isReadOnlyMode = true;
      } else {
        isReadOnlyMode = false;
      }
    }
    if(isReadOnlyMode){
      this.hidePreviousNextButtons = true;
    }
  }
   downloadPayment(row: any) {
     this.isGeneratingPDF = true;
    this.loaderService.show();

    const loaderInterval: number = window.setInterval(() => {
      if (this.isGeneratingPDF) {
        this.loaderService.show();
      } else {
        window.clearInterval(loaderInterval);
      }
    }, 100);

    setTimeout(() => {
      if (!row) {
        this.isGeneratingPDF = false;
        this.loaderService.hide();
        return;
      }
    // Implement your download logic here
    const receiptData = {
      applicantName: row.applicantName || row.applicantName || '',
      applicationId: row.applicationNumber || row.application_id || '',
      referenceNumber: row.transactionId || row.payment_transaction_id || '',
      invoiceNumber: row.invoiceNumber || row.transactionId || row.transaction_id || '',
      paymentMethod: 'Card',
      transactionDate: row.receiptPaymentDate || row.transactionDate || row.transaction_date || '',
      paymentAmount: row.amount ? `$${row.amount}` : '',
      strPaymentTransactionId: row.transactionId || row.transaction_id || '',
      strApplicationNumber: row.applicationNumber || row.application_id || '',
      receiptDate: row.receiptDate,

    };
    this.commonservice.generateReceiptPDF(receiptData, 'download');
    setTimeout(() => {
        this.isGeneratingPDF = false;
        this.loaderService.hide();
      }, 2000);
    }, 100);
  }
    viewPayment(row: any) {
    // Implement your download logic here
    this.isGeneratingPDF = true;
    this.loaderService.show();

    const loaderInterval: number = window.setInterval(() => {
      if (this.isGeneratingPDF) {
        this.loaderService.show();
      } else {
        window.clearInterval(loaderInterval);
      }
    }, 100);

    setTimeout(() => {
      if (!row) {
        this.isGeneratingPDF = false;
        this.loaderService.hide();
        return;
      }
    const receiptData = {
      applicantName: row.applicantName || row.applicantName || '',
      applicationId: row.applicationNumber || row.application_id || '',
      referenceNumber: row.transactionId || row.payment_transaction_id || '',
      invoiceNumber: row.invoiceNumber || row.transactionId || row.transaction_id || '',
      paymentMethod: 'Card',
      transactionDate: row.receiptPaymentDate || row.transactionDate || row.transaction_date || '',
      paymentAmount: row.amount ? `$${row.amount}` : '',
      strPaymentTransactionId: row.transactionId || row.transaction_id || '',
      strApplicationNumber: row.applicationNumber || row.application_id || '',
      receiptDate: row.receiptDate
    };
    this.commonservice.generateReceiptPDF(receiptData, 'view');
    setTimeout(() => {
        this.isGeneratingPDF = false;
        this.loaderService.hide();
      }, 500);
    }, 100);
  }

  notificationOnPaymentFailure() {
    const appId = this.sessionStorage.getItem('youthNumber') || '';
    const userId = this.sessionStorage.getItem('id');
    const notificationPayload = {
      priority: "High",
      message: `Payment failed. Your application ${appId} has not been submitted. Please try again or use a different payment method.`,
      actionurl: "/pages/fingerprint-portal",
      userid: userId,
      customformid: 1,
      isnew: true,
      isactive: true
    };
    this.paymentservice.Submitnotifiction(notificationPayload).pipe(take(1), takeUntil(this.destroy$)).subscribe({
      next: (res: any) => {
        if (res.data.success) {
        }
        else {
          console.error('Error while sending failure notification. Please try again later.');
        }
      },
      error: err => {
        console.error('Error sending failure notification:', err);
      }
    });
  }

  formatStatusText(value: string | undefined): string {
    if (!value) return '';
    return value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
  }

  onUserActivity() {
  this.paymentResetService.resetInactivityTimer();
}
// ngOnDestroy() {
//   this.paymentResetService.stopInactivityTimer();
// }
}
